<div class="modal-header">
  <h5 class="modal-title mt-0">Adicionar Novo Item de Orçamento</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss('Cross click')" aria-hidden="true"></button>
</div>
<form [formGroup]="itemForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label class="form-label" for="grupoId">Categoria<span style="color: red;"> *</span></label>
        <select class="form-select form-select-sm" id="grupoId" formControlName="grupoId"
          [ngClass]="{
            'is-invalid':
            itemForm.controls.grupoId.errors &&
            itemForm.get('grupoId')?.touched,
          }"
        >
          <option value="">Selecione uma categoria</option>
          <option *ngFor="let group of groups" [value]="group.id">
            {{ group.nome }}
          </option>
        </select>
        <div class="invalid-feedback"
          *ngIf="itemForm.get('grupoId')?.touched && itemForm.get('grupoId')?.invalid">
          Selecione uma categoria.
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <div class="form-group">
          <label class="form-label" for="nome">Nome<span style="color: red;"> *</span></label>
          <input type="text" class="form-control form-control-sm" id="nome" placeholder="nome exemplo" formControlName="nome" [ngClass]="{
            'is-invalid':
            itemForm.controls.nome.errors &&
            itemForm.get('nome')?.touched,
          }" />
          <div class="invalid-feedback"
            *ngIf="itemForm.get('nome')?.touched && itemForm.get('nome')?.invalid">
            O nome é obrigatório.
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Quando tipoDeCalculo === 3, os três inputs ficam na mesma linha -->
      <ng-container *ngIf="isTipoCalculo3">
        <div class="col-12 col-md-4 mb-3">
          <div class="form-group">
            <label class="form-label" for="valor">Valor<span style="color: red;"> *</span></label>
            <input currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" type="text"
              class="form-control form-control-sm" id="valor" placeholder="0,00" formControlName="valor" [ngClass]="{
                'is-invalid':
                itemForm.controls.valor.errors &&
                itemForm.get('valor')?.touched,
              }" />
            <div class="invalid-feedback" *ngIf="
              itemForm.controls.valor.errors &&
              itemForm.get('valor')?.touched
            ">
              Informe um valor.
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <div class="form-group">
            <label class="form-label" for="metroQuadrado">M²</label>
            <input type="text" 
              class="form-control form-control-sm" 
              placeholder="0,00"
              formControlName="metroQuadrado"
              mask="separator.2" 
              thousandSeparator="." 
              decimalMarker=","
              [dropSpecialCharacters]="false" />
          </div>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <div class="form-group">
            <label class="form-label" for="metroQuadradoAdicional">M² Adicional</label>
            <input type="text" 
              class="form-control form-control-sm" 
              placeholder="0,00"
              formControlName="metroQuadradoAdicional"
              mask="separator.2" 
              thousandSeparator="." 
              decimalMarker=","
              [dropSpecialCharacters]="false" />
          </div>
        </div>
      </ng-container>

      <!-- Quando tipoDeCalculo !== 3, apenas o input de valor -->
      <ng-container *ngIf="!isTipoCalculo3">
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-label" for="valor">Valor<span style="color: red;"> *</span></label>
            <input currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" type="text"
              class="form-control form-control-sm" id="valor" placeholder="0,00" formControlName="valor" [ngClass]="{
                'is-invalid':
                itemForm.controls.valor.errors &&
                itemForm.get('valor')?.touched,
              }" />
            <div class="invalid-feedback" *ngIf="
              itemForm.controls.valor.errors &&
              itemForm.get('valor')?.touched
            ">
              Informe um valor.
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.dismiss('Close click')">Cancelar</button>
    <button [disabled]="itemForm.invalid || loading" class="btn btn-success" type="submit">
      @if (loading) {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      } @else {
      Salvar
      }
    </button>
  </div>
</form>

